var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGiftMessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 22,
  height: 22,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#002345",
  d: "M28.29 9.58H3.71c-.39 0-.71.32-.71.72v6.14c0 .39.32.71.71.71h.82v13.11c0 .39.32.71.71.71h21.5c.39 0 .71-.32.71-.71V17.15h.82c.39 0 .71-.32.71-.71V10.3c.02-.4-.3-.72-.69-.72m-2.25 19.97H5.96v-12.4h20.08zm1.53-13.82H4.43v-4.72h23.15v4.72z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ff5a38",
  d: "M22.42 1.03c-2.98 0-5.33 3.91-6.43 6.14-.87-1.66-2.51-4.1-4.57-4.1a3.26 3.26 0 0 0 0 6.52h3.16v21.39h2.85V9.58h4.99c2.36 0 4.28-1.92 4.28-4.28s-1.92-4.27-4.28-4.27M9.58 6.32c0-1.01.82-1.83 1.83-1.83 1.33 0 2.72 2.17 3.47 3.67h-3.47c-1 0-1.83-.83-1.83-1.84m12.84 1.84H17.1c1.04-2.19 3.16-5.7 5.32-5.7 1.57 0 2.85 1.28 2.85 2.85s-1.28 2.85-2.85 2.85"
})));
export { SvgGiftMessage as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZmRhYjJlYTM3YWNlZDJkNmFjYzk0OTAxMGYzZDFhOTAuc3ZnIjs=";